import { useAuthStore } from "@/store/authStore";
import { useState } from "react";
import { HelpPanel } from "@/components/help/HelpPanel";

export const AuthHeader: React.FC = () => {
  const { logout } = useAuthStore();
  const [showHelp, setShowHelp] = useState(false);

  const handleLogout = () => {
    logout();
  };

  return (
    <>
      <div className="flex items-center gap-3">
        {/* User Info */}
        <div className="flex items-center gap-2.5 text-sm">
          <div className="w-9 h-9 bg-white bg-opacity-15 rounded-full flex items-center justify-center text-white font-semibold border border-white border-opacity-20 backdrop-blur-sm">
            U
          </div>
          <span className="font-medium text-white text-sm">
            Welcome, user
          </span>
        </div>

        {/* Help Button */}
        <button
          onClick={() => setShowHelp(true)}
          className="px-4 py-2 text-sm font-medium text-custom-navy bg-white rounded-md hover:bg-custom-light-50 transition-all duration-200 shadow-sm hover:shadow-md"
        >
          Help
        </button>

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="px-4 py-2 text-sm font-medium text-white bg-white bg-opacity-10 border border-white border-opacity-20 rounded-md hover:bg-opacity-20 transition-all duration-200 backdrop-blur-sm"
        >
          Logout
        </button>
      </div>

      {/* Help Modal */}
      {showHelp && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col m-4">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-4 bg-custom-navy border-b border-custom-dark">
              <h2 className="text-xl font-semibold text-white">Help & Support</h2>
              <button
                onClick={() => setShowHelp(false)}
                className="text-white hover:text-custom-light-100 transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Modal Content */}
            <div className="flex-1 overflow-y-auto p-6">
              <HelpPanel />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
